import { getRequestPlatform, WECHAT_MINIPROGRAM_PLATFORM } from '@/app/constants';

export const DATA_FINDER_PLATFORM_TYPES = {
  miniapp: 'wechat_miniprogram',
  web: 'web',
} as const;

export type DataFinderPlatformType = (typeof DATA_FINDER_PLATFORM_TYPES)[keyof typeof DATA_FINDER_PLATFORM_TYPES];

export const resolveDataFinderPlatformType = (): DataFinderPlatformType => {
  return getRequestPlatform() === WECHAT_MINIPROGRAM_PLATFORM
    ? DATA_FINDER_PLATFORM_TYPES.miniapp
    : DATA_FINDER_PLATFORM_TYPES.web;
};
